/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Button, Popup as SemanticUIPopup } from 'semantic-ui-react';
import DeleteStep from '../../DeleteStep';
import { TrashIcon } from '../../../assets/icons';

import styles from './Item.module.scss';

const Item = React.memo(({ id, name, url, onDelete }) => {
  const [t] = useTranslation();

  const handleDelete = useCallback(() => {
    onDelete({
      id,
    });
  }, [id, onDelete]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.details}>
        <img src={url} alt={name} />
      </div>
      <SemanticUIPopup
        position="bottom center"
        trigger={
          <Button className={styles.buttonDelete}>
            <TrashIcon className={styles.menuIcon} />
          </Button>
        }
        content={
          <DeleteStep
            title={t('common.deleteArchitature', {
              context: 'title',
            })}
            content={t('common.areYouSureYouWantToDeleteThisArchitecture')}
            buttonContent={t('action.deleteArchitature')}
            onConfirm={handleDelete}
          />
        }
        on="click"
        hideOnScroll
      />
    </div>
  );
});

Item.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  url: PropTypes.string,
  onDelete: PropTypes.func.isRequired,
};

Item.defaultProps = {
  url: undefined,
};

export default Item;
